import React from "react";
import Address from "./Main page/Hero section/Address";
import Services from "./Services";

function Delivery() {
  return (
    <>
      <a href="#" id="delivery"></a>
      <Services />
      <div className="px-4 text-2xl font-bold font-fancy h-fit">
        <div className="bg-gradient-to-l bg-clip-text text-transparent animate-text from-yellow-600 via-fuchsia-700 to-orange-300 bg-[length:1100px] text-4xl">
          Free Home Delivery
        </div>
        <p className="text-lg font-light ">
          (Charges applied on out of town orders)
        </p>
      </div>
      <div className="flex justify-evenly">
        <div>
          <div className="flex flex-col items-center p-2 mt-3">
            <h3 className="my-2 text-xl font-bold text-transparent font-fancy bg-clip-text bg-gradient-to-r from-amber-700 to-amber-300">
              Pir Mahal Branch
            </h3>
            <a href="tel:046 3366333" target="_blank" rel="noreferrer noopener">
              <button className='"bg-white animate-button flex items-center text-green-600/70 text-md px-3 py-2 font-fancy rounded-full hover:drop-shadow-xl hover:text-green-600 shadow-xl shadow-gray-400 cursor-pointer  transition-all duration-75 group'>
                Give us a Call
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-10 h-5 group-hover:text-green-600"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
                  />
                </svg>
              </button>
            </a>
          </div>
        </div>
        <div></div>
      </div>

      <Address />
    </>
  );
}

export default Delivery;
